import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import StaffDepartmentsDt from '@/services/dataTransferModules/staffDepartmentsDt'

export default function useStaffDepartments(params = {}) {
	const staffDepartmentsDt = new StaffDepartmentsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingStaffDepartment: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: fullStaffDepartments,
		getEntities: getStaffDepartments,

		createEntity: createStaffDepartment,

		entity: staffDepartment,
		getEntity: getStaffDepartment,

		entityPreview: previewStaffDepartments,
		getEntityPreview: getStaffDepartmentsPreview,

		patchEntity: patchStaffDepartment,
		updateEntity: putStaffDepartment,

		deleteEntity: deleteStaffDepartment,
	} = useBlProviders(
		staffDepartmentsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error loading employee!'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		fullStaffDepartments,
		previewStaffDepartments,
		staffDepartment,
		defaults,

		getStaffDepartments,
		getStaffDepartmentsPreview,
		getStaffDepartment,
		createStaffDepartment,
		patchStaffDepartment,
		putStaffDepartment,
		deleteStaffDepartment,
	}
}
